module.exports = __webpack_public_path__ + "img/logo_Q_Analytics.96746576.svg";